module.exports = __webpack_public_path__ + "static/media/599.702.3ab7de3f.pdf";